<template>
    <div>
        <el-upload
                class="upload-demo"
                action="/index.php/user/User/uploadwater"
                :on-success="handleSuccess"
                :on-remove="handleRemove"
                name="image"
                :before-remove="beforeRemove"
                :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过4MB</div>
        </el-upload>
    </div>
</template>

<script >
  export default {
	props: ['cl'],
    name: "FontOnlyUpload",
    data(){
      return {
        fileList:[],
        img_list:[]
      }
    },
	watch: {
	    cl(newValue, oldValue) {
			if(newValue){
				console.log(newValue)
				this.img_list=[]
				this.fileList=[]
			}
	    }
	},
    methods:{
      handleSuccess(response, file, fileList) {
		this.cl=false;
        if(response.status!=200){
          this.$message({
            type: 'error',
            message:"非法图片",
			offset:300
          });
          this.fileList=fileList.slice(0,-1);
          return false
        }
        // @ts-ignore
        this.img_list.push(response.data);
        this.$emit('input',JSON.stringify(this.img_list));
      },
      handleRemove(file,fileList) {
        // @ts-ignore
        this.img_list.splice(this.img_list.indexOf(file.response.data),1);
		this.$emit('input',JSON.stringify(this.img_list));
      },
      beforeRemove(file) {
        return this.$confirm(`确定移除 ${ file.name }?`);
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

</style>



// WEBPACK FOOTER //
// src/components/Font-onlyuoload.vue